import { TicketType } from './ticket-type.enum';

export interface BookingSummaryTicket {
  id: number;
  title: string;
  summary: string;
  subTotalPrice: number;
  count: number;
  type: TicketType;
  travelMethod: string;
  zone: string;
  isDirectDebit: boolean;
  alias: string;
  subtitle: string;
  termDateFrom: string;
  termDateTo: string;
  minAgeBand?: number;
  maxAgeBand?: number;
}
